module.exports = __webpack_public_path__ + "media/Video 31.dff8442c.mp4";